import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
let uid = 0;
/**
 * Sample usage:
 *
 *     <expandable expandableTitle="Title">
 *         Lorem ipsum dolor
 *     </expandable>
 */
@Component({
    selector: 'expandable',
    templateUrl: './expandable.html',
    styleUrls: ['./expandable.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ZippyModule, CommonModule]
})
export class ExpandableComponent {
    /**
     * Title
     */
    @Input()
    expandableTitle?: string;
    /**
     * Zippy id
     */
    @Input()
    expandableId?: string | (string | number)[];
    /**
     * Default zippy id
     */
    readonly defaultId = `expandable.${uid++}`;
    /**
     * Dependencies
     */
    constructor() { }
    get zippyId() {
        return this.expandableId || this.defaultId;
    }
}
